import { render } from "./index.vue?vue&type=template&id=28d1480f&scoped=true"
import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=28d1480f&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28d1480f"],['__file',"src/views/jbh/achievementManage/complaintManage/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "28d1480f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('28d1480f', __exports__)) {
    console.log('reload')
    api.reload('28d1480f', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=28d1480f&scoped=true", () => {
    console.log('re-render')
    api.rerender('28d1480f', render)
  })

}


export default __exports__